import application from 'application/application';

import 'select2';

application.directive('ngCustomSelectSearchHistory', [
	'$timeout',
	'API',
	'environment',
	($timeout, API, environment) => ({
		restrict: 'A',
		scope: {},
		link(scope, element, attributes) {
			$.fn.select2.defaults.set('language', {
				inputTooLong: args => {
					let overChars = args.input.length - args.maximum;

					return `Apague ${overChars} caracter${overChars > 1 ? 'es' : ''}`;
				},
				inputTooShort: args => {
					let remainingChars = args.minimum - args.input.length;

					return `Digite ${remainingChars} ou mais caracteres`;
				},
				maximumSelected: args => {
					const maximumSelection = args.maximum;

					return `Você só pode selecionar ${maximumSelection} ite${
						maximumSelection > 1 ? 'ns' : 'm'
					}`;
				},
				searching: () => 'Buscando…',
				removeAllItems: () => 'Remover todos os itens',
				noResults: () => 'Nenhum resultado encontrado',
				loadingMore: () => 'Carregando mais…',
				errorLoading: () => 'Os resultados não puderam ser carregados.'
			});

			let getCustomUrl = API[attributes.paths].paths[attributes.customUrl];

			let url = `https://homologacao-api.advise.com.br/core/v1/${getCustomUrl}`;

			if (environment.name === 'homologation')
				url = `https://homologacao-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (API.default.hostname.includes('sandbox-'))
				url = `https://sandbox-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (environment.name === 'production')
				url = `https://api.advise.com.br/core/v1/${getCustomUrl}`;

			const headers = localStorage.getItem('__authenticationToken__')
				? {
						Authorization:
							'Bearer ' + localStorage.getItem('__authenticationToken__')
				  }
				: {};

			const customSearch = attributes.ngCustomRegex
				? eval(`(${attributes.ngCustomRegex})`)
				: false;

			scope.allResults = [];
			const typeProcess = +attributes.ngHistoryType === -3;

			let currentTerm = {
				id: '',
				text: '',
				value: -3,
				history: false,
				current: true
			};

			$(element)
				.select2({
					width: '100%',
					placeholder: attributes.placeholder,
					minimumInputLength: attributes.minimumLengthToSearch,
					dropdownParent:
						'ngSelectRelativeElement' in attributes
							? $(element).closest(
									attributes.ngSelectRelativeElement
										? attributes.ngSelectRelativeElement
										: 'body'
							  )
							: $(element).closest('.modal').length
							? $(element).closest('form')
							: '',
					containerCssClass: attributes.customSelectClass,
					dropdownCssClass: attributes.customDropClass,
					ajax: {
						delay: 250,
						url: url,
						headers: headers,
						data(params) {
							scope.paginaAtual = params.page;
							currentTerm.text = params.term;
							currentTerm.nome = params.term;
							currentTerm.id = params.term;

							let object = {
								paginaAtual: params.page || 1,
								registrosPorPagina: 10
							};

							object[
								attributes.ngSelectParam || 'nomePalavraChave'
							] = customSearch
								? params.term
									? customSearch(params.term)
									: null
								: params.term;

							object['paginaAtual'] = params.page || 1;

							if (attributes.ngSelectActive)
								object['ativo'] = attributes.ngSelectActive;

							if (attributes.ngFields) object['Campos'] = attributes.ngFields;

							if (attributes.ngGroupId)
								object['IdGrupo'] = attributes.ngGroupId;

							if (attributes.ngGroupUserId)
								object['IdGrupoUsuarios'] = attributes.ngGroupUserId;

							if (attributes.ngTipoPasta)
								object['idTipoPasta'] = attributes.ngTipoPasta;

							return object;
						},
						processResults(data) {
							const historyArray =
								JSON.parse(
									localStorage.getItem(
										`__${typeProcess ? 'process' : 'keyword'}SearchHistory__`
									)
								) || [];

							const searchHistory = !scope.paginaAtual
								? [...[currentTerm], ...historyArray]
								: [];

							scope.allResults = [...scope.allResults, ...searchHistory];

							if (data.itens) {
								scope.resultsData = data.itens;
								scope.allResults = [...scope.allResults, ...data.itens];

								return {
									results: [
										// ...[currentTerm],
										...searchHistory,
										...scope.resultsData.map(item => {
											const results = {
												id: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPalavraChave || item.id,
												text: attributes.ngCustomLabel
													? item[attributes.ngCustomLabel]
													: item.nomePasta || item.nome,
												value: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPalavraChave || item.id
											};

											if (item.idProcesso) results.idProcesso = item.idProcesso;

											results.search = currentTerm;

											scope.results = results;

											return results;
										})
									],
									pagination: {
										more: data.itens.length === 10 ? true : false
									}
								};
							}

							return {
								results: [...searchHistory],
								pagination: {
									more: false
								}
							};
						}
					},
					templateResult: item => customizeElement(item),
					templateSelection: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					theme: attributes.customSelectTheme
				})

				.on('select2:open', () => {
					$('.select2-results__options').on('mousedown', e => {
						if (e.button == 1) return false;
					});

					$('input.select2-search__field').prop('placeholder', 'Busca');
				})

				.on('select2:select', event =>
					$timeout(() => {
						const value = $(event.currentTarget)
							.find('option:selected')
							.val();

						const currentIsSelected = currentTerm.id === value;

						if (currentIsSelected) {
							storeSearchHistoryItem(currentTerm, +attributes.ngHistoryType);
							$(element).attr('current', true);
							$(element).attr('ng-custom-model', value);
							$(element).attr('ng-process-value', value);
							$(element).attr('ng-history-search', value);
						} else {
							const itemSelected = scope.allResults.find(
								({ idPalavraChave, id }) => (idPalavraChave || id) === +value
							);

							if (itemSelected.idProcesso) {
								storeSearchHistoryItem(itemSelected, +attributes.ngHistoryType);

								$(element).attr('ng-custom-model', itemSelected.idProcesso);
								$(element).attr('ng-process-value', itemSelected.id);
								$(element).attr('ng-history-search', itemSelected.nome);
							} else {
								storeSearchHistoryItem(itemSelected, +attributes.ngHistoryType);

								$(element).attr('ng-custom-model', value);
							}
						}

						scope.$apply();
					})
				)

				.on('select2:opening', () =>
					$(window).on('resize.select2', () => $(element).select2('close'))
				)

				// Desatch resize event on close
				.on('select2:closing', () => $(window).off('resize.select2'));

			scope.$watch('ngModel', (newValue, oldValue) => {
				const stringify = val =>
					typeof val === 'object' ? JSON.stringify(val) : val;

				if (stringify(newValue) == stringify(oldValue)) return;

				$timeout(() => {
					element.triggerHandler('change.select2');

					$(element).trigger('change');
				});
			});
		}
	})
]);

function customizeElement(el) {
	if (el.history) {
		let div = document.createElement('div');

		div.classList = 'd-flex';

		const iconSearch = '<i class="material-icons mr-2">schedule</i>';

		div.innerHTML = iconSearch;

		let text = document.createTextNode(el.text);

		div.appendChild(text);

		return div;
	} else if (el.current) {
		let div = document.createElement('div');

		div.classList = 'd-flex';

		const iconSearch = '<i class="material-icons mr-2">search</i>';

		div.innerHTML = iconSearch;

		let text = document.createTextNode(el.text);

		div.appendChild(text);

		return div;
	} else if (el.search) {
		let text = document.createElement('span');

		text.class = 'font-md';

		const regex = new RegExp(`(${el.search.text})`, 'i');

		text.innerHTML = el.text.replace(regex, '<b class="font-medium">$1</b>');

		return text;
	} else {
		return el.text;
	}
}

function storeSearchHistoryItem(item, type) {
	const typeProcess = type === -3;

	const itemHistory = {
		id: typeProcess ? +item.id : +item.idPalavraChave || +item.id,
		text: typeProcess ? item.nome : item.nomePasta,
		value: typeProcess ? +item.id : +item.idPalavraChave || +item.id,
		history: true
	};

	if (item.current) {
		itemHistory.id = item.id;
		itemHistory.nome = item.id;
		itemHistory.value = item.id;
		itemHistory.search = true;
	}

	if (typeProcess) {
		itemHistory.idProcesso = +item.idProcesso;
	}

	let searchHistory =
		JSON.parse(
			localStorage.getItem(
				`__${typeProcess ? 'process' : 'keyword'}SearchHistory__`
			)
		) || [];

	if (searchHistory) {
		const hasItemHistory = searchHistory.some(
			({ id }) => id === itemHistory.id
		);

		if (hasItemHistory) {
			searchHistory.sort(a => {
				return a.id === itemHistory.id ? -1 : 1;
			});
		} else {
			searchHistory.unshift(itemHistory);

			if (searchHistory.length > 5) {
				searchHistory.pop();
			}
		}
	} else {
		searchHistory.unshift(itemHistory);
	}

	localStorage.setItem(
		`__${typeProcess ? 'process' : 'keyword'}SearchHistory__`,
		JSON.stringify(searchHistory)
	);
}
